import { render } from "./ValueSlides.vue?vue&type=template&id=1c553588&scoped=true"
import script from "./ValueSlides.vue?vue&type=script&lang=js"
export * from "./ValueSlides.vue?vue&type=script&lang=js"

import "./ValueSlides.vue?vue&type=style&index=0&id=1c553588&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c553588"]])

export default __exports__